export const SELECTED_TAB = "SELECTED_TAB";
export const SELECTED_APPLICATION_TAB = "SELECTED_APPLICATION_TAB";
export const PERSONAL_INFO = "PERSONAL_INFO";
export const GENERATED_SHORTLIST = "GENERATED_SHORTLIST";
export const PLANNER_ID = "PLANNER_ID";
export const PLANNER_FORM_DATA = "PLANNER_FORM_DATA";
export const ARGONAUT = "ARGONAUT";
export const APPLICATION_FORM_DATA = "APPLICATION_FORM_DATA";
export const SET_SHORTLISTED_PROGRAMS = "SET_SHORTLISTED_PROGRAMS";
export const FETCHING_SHORTLIST = "FETCHING_SHORTLIST";
export const SET_AUTOFILL_STATUS = "SET_AUTOFILL_STATUS";
